import axios from 'axios';
import { getBaseApiUrl } from '../config';
// config

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: getBaseApiUrl() });

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `${token}`;
    }

    Object.entries(config.params || {})
      .filter(([_, value]) => !value)
      .forEach(([key]) => {
        delete config.params[key];
      });

    // Prevent the browser from serving cached GET responses. These endpoints
    // share the same URL across clients (the token only lives in a header), so
    // without this a second client can be served the first client's cached body
    // — e.g. a stale `before_deposit_forms`, requiring a manual hard reload.
    // The `_t` query param guarantees a unique URL even if the server keeps
    // sending cacheable headers. Added after the falsy-param strip above so it
    // isn't removed.
    if ((config.method || 'get').toLowerCase() === 'get') {
      config.headers['Cache-Control'] = 'no-cache';
      config.headers.Pragma = 'no-cache';
      config.params = { ...config.params, _t: Date.now() };
    }

    return config;
  },
  (error) => {
    // Handle request errors
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle response errors
    if (error.response) {
      // The request was made and the server responded with a status code
      console.error('Response error:', error.response.data);
      console.error('Status code:', error.response.status);
      if (error?.response?.status === 401 || error?.response?.status === 429) {
        const isLoginPage = window.location.pathname === '/login';
        if (!isLoginPage) {
          window.location.replace(window.location.origin + '/login');
          localStorage.clear();
          sessionStorage.clear();
        }
        console.error('error', error.response.status);
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('No response received:', error.request);
    } else {
      // Something happened in setting up the request that triggered an error
      console.error('Error:', error.message);
    }
    return Promise.reject((error.response && error.response.data) || error?.errors || 'Something went wrong');
  }
);

export default axiosInstance;
